import { VAlert } from 'vuetify/lib/components/VAlert';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VAlert,{attrs:{"type":_vm.type,"outlined":_vm.outlined,"dismissible":_vm.dismissible,"value":_vm.visible}},[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }